import { render, staticRenderFns } from "./data-report-img-dialog.vue?vue&type=template&id=20c27e22&scoped=true&"
import script from "./data-report-img-dialog.vue?vue&type=script&lang=js&"
export * from "./data-report-img-dialog.vue?vue&type=script&lang=js&"
import style0 from "./data-report-img-dialog.vue?vue&type=style&index=0&id=20c27e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c27e22",
  null
  
)

export default component.exports